import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { House, ShoppingCart, Phone } from 'phosphor-react';
import './NotFound.css';

const NotFound = () => {
  const location = useLocation();

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="error-code">404</div>
        <h1 className="error-title">Página não encontrada</h1>
        <p className="error-message">
          A página <code>{location.pathname}</code> que está a procurar não existe.
        </p>
        
        <div className="error-suggestions">
          <h3>O que pode fazer:</h3>
          <ul>
            <li>Verificar se o endereço está correto</li>
            <li>Regressar à página inicial</li>
            <li>Explorar os nossos produtos</li>
            <li>Contactar-nos se precisar de ajuda</li>
          </ul>
        </div>

        <div className="error-actions">
          <Link to="/" className="btn btn-primary">
            <House size={20} />
            Voltar ao Início
          </Link>
          <Link to="/shop" className="btn btn-secondary">
            <ShoppingCart size={20} />
            Ver Produtos
          </Link>
          <Link to="/contactos" className="btn btn-outline">
            <Phone size={20} />
            Contactar
          </Link>
        </div>

        <div className="error-footer">
          <p>Se continuar com problemas, contacte-nos em:</p>
          <a href="mailto:support@mercadotv.com">support@mercadotv.com</a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
